import React from "react";
import Stack from "@mui/material/Stack";
import { StyledPagination } from "../styled/Pagination.styled";
import PropTypes from "prop-types";

export default function Pagination({
  page,
  getPage,
  count,
  onPageChange,
  ...props
}) {
  const handleChange = (event, value) => {
    //send API call to get data related to current page
    //onPageChange
    getPage(value);
  };

  return (
    <Stack spacing={2}>
      <StyledPagination
        count={count}
        page={page}
        onChange={handleChange}
        variant="outlined"
        shape="rounded"
        {...props}
      />
    </Stack>
  );
}

Pagination.propTypes = {
  variant: PropTypes.string,
  shape: PropTypes.string,
  count: PropTypes.number,
  onPageChange: PropTypes.func,
};

Pagination.defaultProps = {
  variant: "outlined",
  shape: "rounded",
  count: 0,
  onPageChange: undefined,
};
